import React, { useEffect, useRef, useState } from "react";

export default function SignaturePad({ onChange, resetKey }) {
  const canvasRef = useRef(null);
  const drawing = useRef(false);
  const [hasMark, setHasMark] = useState(false);
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ratio = Math.max(window.devicePixelRatio || 1, 1);
    const rect = canvas.getBoundingClientRect();
    canvas.width = Math.floor(rect.width * ratio);
    canvas.height = Math.floor(rect.height * ratio);
    const ctx = canvas.getContext("2d");
    ctx.scale(ratio, ratio);
    ctx.lineWidth = 2.2;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
    ctx.strokeStyle = "#203b42";
    setHasMark(false);
    onChange("");
  }, [resetKey, onChange]);
  const position = (event) => {
    const rect = canvasRef.current.getBoundingClientRect();
    return { x: event.clientX - rect.left, y: event.clientY - rect.top };
  };
  const start = (event) => {
    event.preventDefault();
    const canvas = canvasRef.current;
    canvas.setPointerCapture(event.pointerId);
    drawing.current = true;
    const p = position(event);
    const ctx = canvas.getContext("2d");
    ctx.beginPath();
    ctx.moveTo(p.x, p.y);
    ctx.lineTo(p.x + 0.1, p.y + 0.1);
    ctx.stroke();
    setHasMark(true);
  };
  const move = (event) => {
    if (!drawing.current) return;
    event.preventDefault();
    const p = position(event);
    const ctx = canvasRef.current.getContext("2d");
    ctx.lineTo(p.x, p.y);
    ctx.stroke();
  };
  const end = () => {
    if (!drawing.current) return;
    drawing.current = false;
    const canvas = canvasRef.current;
    onChange(canvas.toDataURL("image/png"));
  };
  const clear = () => {
    const canvas = canvasRef.current;
    canvas.getContext("2d").clearRect(0, 0, canvas.width, canvas.height);
    drawing.current = false;
    setHasMark(false);
    onChange("");
  };
  return (
    <div className="recruit-signature-box">
      <canvas ref={canvasRef} aria-label="Draw your signature" role="img" onPointerDown={start} onPointerMove={move} onPointerUp={end} onPointerCancel={end} />
      <div className="recruit-signature-tools">
        <span>{hasMark ? "Signature captured" : "Draw your signature above"}</span>
        <button className="recruit-button" type="button" onClick={clear}>Clear signature</button>
      </div>
    </div>
  );
}